import { useChannel } from "ably/react";
import { createContext } from "react";

interface RealtimeContext {
    useChannel?: typeof useChannel;
}

export const RealtimeContext = createContext<RealtimeContext>({});
RealtimeContext.displayName = "Ably";
